import { TMedia } from '@renderer-ui-library/molecules'
import { TMachineMedia } from '@internal/utils/machine/TMachineMedia'

export const isMachineMedia = (
  media: TMedia
): media is { id: number; attributes: TMachineMedia } =>
  !!(media.attributes as TMachineMedia).source
